(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentAssignGradPlan, 
        ['$rootScope', '$http', '$uibModal', 
	      schoolwork12.app.auth.services.authentication,
	      schoolwork12.app.common.services.utilService,
        function($rootScope, $http, $uibModal, authentication, utilService) {

  		var service  = function assignGradPlanModal(gradPlansList, selectedStds) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentAssignGradPlan,
			    size: 'lg',
			    backdrop: 'static',
			    controller: ['$scope', '$uibModalInstance',
		        function ($scope, $uibModalInstance) {
		       		console.log("Viewing graduation plans to be assigned");
				
			    //initialize default settings
			    $scope.diplomaErrorMesg = "";
			    $scope.saveDiplomaErrorOccured = false;
			    $scope.isAssignStudentsToGradPlanBusy = false;
			   
			    $scope.selectedStudents = selectedStds;    
			    $scope.gridOptions = {
					enableRowSelection : true,
					enableRowHeaderSelection : true,
					showGridFooter : true,
					multiSelect: false,
					enableCellEditOnFocus : true,
					rowHeight: 50
			    };

			    $scope.gridOptions.data = gradPlansList.data;
			    $scope.studentsCount = selectedStds.length;
			    $scope.school = selectedStds[0].schoolAbbr;
			   
			    //enable Add button only if any row is selected
			    $scope.gridOptions.onRegisterApi = function (gridApi) {
	                $scope.gridApi = gridApi;
			    	$scope.gridApi.selection.on.rowSelectionChanged($scope,function(row){ 
			    		$scope.rowSelected =  row.isSelected;
			    		$scope.diplomaID = row.entity.id;
			    	});
            	};

            	//Custom cell template to indicate default diploma
			    var diplomaCellTemplate = '<div class="ui-grid-cell-contents"> {{grid.getCellValue(row, col)}}' +  
			    '<span ng-show="row.entity.defaultDiploma == true"> - <span class="label label-default"> Default Plan </span></span>' + 
			    '</div>';

			    var createdOnCellTemplate = '<div class="ui-grid-cell-contents alignDate"> {{grid.getCellValue(row, col)}}' +  
			    '</div>';

            	//build column definitions
				$scope.gridOptions.columnDefs = [
				    { field: 'name', displayName: 'Graduation Plan', width: '60%', cellTemplate: diplomaCellTemplate},
			    	{ field: 'createDate', displayName: 'Created On', cellTemplate: createdOnCellTemplate, 
			    	sort: {direction: 'desc'}, sortingAlgorithm: utilService.sortDateFn}
				];


			    //on click of Assign, save and add students to grad plan
			    	$scope.assignDiplomaToStudents = function () {
			    		$scope.isAssignStudentsToGradPlanBusy = true;
		             	$http({
			                url : schoolwork12.app.student.endpoints.diplomaAssign + $scope.diplomaID + '/students',
			              	method : "PUT",
			              	data : {
									 "studentSchoolList" : $scope.selectedStudents
									},
		        		  	headers : {
		        		  				'Content-Type': 'application/json',
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
			              	}).success(function (response) {
			              		console.info("Students assigned to graduation plan successfully", response);
	            	   			$rootScope.assignedDiplomaSuccessfully = true;
	            	   			$scope.closeSuccessClick = false;
			              		$uibModalInstance.close();
			              	}).error(function(error){ 
			              		$scope.saveDiplomaErrorOccured = true;
			                	console.info('Error in assigning students to graduation plan....'.concat(angular.toJson(error)));
			                	if (error.status == 400) {
									for ( var j = 0; j < error.data._errors.length; j++) {
										$scope.diplomaErrorMesg = $scope.diplomaErrorMesg + error.data._errors[j] + "\n";
									}
								} else if (error.status == 401 || error.status == 403) {
			                        $scope.diplomaErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
			                    } else {
			                        $scope.diplomaErrorMesg = schoolwork12.app.errorMessages.internalError;
			                    }
			            });
						
					}; 
				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};
			}],
		  	    
		});

	};

    return {
    	service: service
    };

}]);
    
}(angular, schoolwork12));